<template>
  <div class="w-full" id="AboutYourself">
    <ValidationObserver tag="form" ref="AboutYourself" v-slot="observer">
      <h2 data-prefix="1" class="mb-5 text-4xl font-semibold leading-7">About you</h2>
      <div class="mt-2 mb-8">
        <ValidationProvider name="Title" rules="required">
            <div slot-scope="{ errors }">
              <label class="font-semibold label" for="title">Title</label>
              <fieldset>
                    <legend class="font-semibold label" for="title">Title</legend>
                    <div class="inline" v-for="titleEntry in salutations" :key="titleEntry">
                      <input type="radio" name="title" v-model="title" :id="titleEntry" :value="capatilise(titleEntry)"/>
                      <label @keypress.enter.prevent="$event.target.click" tabindex="0"  :class="{ 'border-error': errors[0] }" class="label-select" :for="titleEntry">
                        {{ capatilise(titleEntry) }}
                        <TickIcon class="tick-icon"/>
                      </label>
                    </div>
                  </fieldset>
              <p :class="{ 'pt-2': errors[0] }" class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
      </div>
      <div class="flex flex-wrap mb-4 -mx-3">
        <div class="w-full px-3 mb-4 md:w-3/12 md:w-auto md:mb-0">
          <!-- first name -->
          <label class="font-semibold label" for="firstname">First name</label>
          <ValidationProvider name="First name" rules="required|min:2|max:32">
            <div slot-scope="{ errors }">
              <input tabindex="0" v-model.trim="firstName" :class="{ 'border-error': errors[0] }" class="input focus:outline-none" id="firstname" type="text">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
        <div class="w-full px-3 md:w-3/12">
          <!-- last name -->
          <label class="font-semibold label" for="lastname">Last name</label>
          <ValidationProvider name="Last name" rules="required|min:2|max:32">
            <div slot-scope="{ errors }">
              <input tabindex="0" v-model.trim="lastName" :class="{ 'border-error': errors[0] }" class="input focus:outline-none" id="lastname" type="text">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <label class="font-semibold label">Date of birth</label>
      <p class="mb-2">For example, 21 04 1995</p>
      <div class="flex flex-wrap mb-2 -mx-3">

      <div class="w-full px-3 md:w-40">
        <!-- day of birth -->
        <ValidationProvider name="Day" rules="required|numeric|between:1,31">
          <div slot-scope="{ errors }">
            <label class="font-semibold label" for="dayOfBirth">Day</label>
            <input tabindex="0" placeholder="Day" v-model.trim="dayOfBirth" :class="{ 'border-error': errors[0] }" class="placeholder-polgrey-dark input focus:outline-none" id="dayOfBirth" type="number" autocomplete="off">
            <p class="text-polred">{{ errors[0] }}</p>
          </div>
        </ValidationProvider>
      </div>

      <div class="w-full px-3 md:w-40">
        <!-- month of birth -->
        <ValidationProvider  name="Month" rules="required||numeric|between:1,12">
          <div slot-scope="{ errors }">
            <label class="font-semibold label" for="monthOfBirth">Month</label>
            <input tabindex="0" placeholder="Month" v-model.trim="monthOfBirth" :class="{ 'border-error': errors[0] }" class="placeholder-polgrey-dark input focus:outline-none" id="monthOfBirth" type="number">
            <p class="text-polred">{{ errors[0] }}</p>
          </div>
        </ValidationProvider>
      </div>

      <div class="w-full px-3 md:w-40">
        <!-- year of birth -->
        <ValidationProvider name="Year" rules="required||numeric|between:1900,2020">
          <div slot-scope="{ errors }">
            <label class="font-semibold label" for="yearOfBirth">Year</label>
            <input tabindex="0" placeholder="Year" v-model.trim="yearOfBirth" :class="{ 'border-error': errors[0] }" class="placeholder-polgrey-dark input focus:outline-none" id="yearOfBirth" type="number">
            <p class="text-polred">{{ errors[0] }}</p>
          </div>
        </ValidationProvider>
      </div>

      </div>
      <div class="flex flex-wrap mt-2 -mx-3 sm:mt-4">
        <div class="w-full px-3 md:w-3/12">
          <!-- email address -->
          <ValidationProvider name="Email" rules="required|email|min:1|max:50">
            <div slot-scope="{ errors }">
              <label class="font-semibold label" for="email">Email</label>
              <input tabindex="0" v-model.trim="emailAddress" :class="{ 'border-error': errors[0] }" class="input focus:outline-none" id="email" type="email">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="flex flex-wrap mt-4 -mx-3">
        <div class="w-full px-3 mb-4 md:w-3/12 md:mb-0">
          <!-- mobile number -->
          <label class="font-semibold label" for="mobilePhoneNumber">Mobile number</label>
          <ValidationProvider name="Mobile number" rules="required|min:1|max:11|numeric">
            <div slot-scope="{ errors }">
              <input tabindex="0" v-model.trim="mobilePhoneNumber" :class="{ 'border-error': errors[0] }" class="input focus:outline-none" id="mobilePhoneNumber" type="tel">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
      </div>

      </ValidationObserver>
  </div>
</template>

<script>

import TickIcon from '@/v2/assets/images/icons/select-tick.svg';
import mixins from '@/v2/mixins'

import { mapFields } from 'vuex-map-fields'
import { salutations } from '../../../form'

export default {
  name: 'AboutYourself',
  mixins: [mixins],
  data() {
    return {
      salutations,
      yearOfBirth: '',
      monthOfBirth: '',
      dayOfBirth: '',
    }
  },
  components: {
    TickIcon,
  },
  created() {
    this.splitDateOfBirthFieldsAndDisplay()
  },
  methods: {},
  computed : {
    birthDateCombined() {
      return this.yearOfBirth, this.monthOfBirth, this.dayOfBirth, Date.now()
    },
    ...mapFields([
      'person.title',
      'person.firstName',
      'person.lastName',
      'person.emailAddress',
      'person.birthDate',
      'person.mobilePhoneNumber'
    ])
  },
  watch: {
    birthDateCombined() {
      this.birthDate = `${this.zeroPad(this.yearOfBirth, 2)}-${this.zeroPad(this.monthOfBirth, 2)}-${this.zeroPad(this.dayOfBirth, 2)}`
    }
  }
}
</script>